export const trnsOptions = [
  {
    value: 'ACATC',
    label: 'ACATC',
    description: 'ACATC IN/OUT (Cash)',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'ACATS',
    label: 'ACATS',
    description: 'ACATC IN/OUT (Securities)',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'ACCTCLR',
    label: 'ACCTCLR',
    description: 'Account Clear',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'ALLOC',
    label: 'ALLOC',
    description: 'Allocation',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'CFEE',
    label: 'CFEE',
    description: 'Cypto Fee Entry',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'CGD',
    label: 'CGD',
    description: 'Capital Gains Distribution',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'CIL',
    label: 'CIL',
    description: 'CIL',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'CORR',
    label: 'CORR',
    description: 'Corrected trade entry',
    screen: 'Trade',
    screen_no: 1,
  },
  {
    value: 'CSD',
    label: 'CSD',
    description: 'Cash disbursement(+)',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'CSW',
    label: 'CSW',
    description: 'Cash Withdrawal',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'DIV',
    label: 'DIV',
    description: 'Dividends',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'DIVNRA',
    label: 'DIVNRA',
    description: 'Div. Adj(NRA Withheld)',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'DIVPWH',
    label: 'DIVPWH',
    description: 'Div. product Withholding',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'DIVWH',
    label: 'DIVWH',
    description: 'Div. Withholding',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'DTCC',
    label: 'DTCC',
    description: 'DTCC Cash Movement',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'DTCS',
    label: 'DTCS',
    description: 'DTCC Share Movement',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'EXTRD',
    label: 'EXTRD',
    description: 'External Trade',
    screen: 'Trade',
    screen_no: 1,
  },
  {
    value: 'FEE',
    label: 'FEE',
    description: 'Fee',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'FIMAT',
    label: 'FIMAT',
    description: 'Fixed Income Maturity',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'FOPT',
    label: 'FOPT',
    description: 'Free of Payment Transfer',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'FXCNV',
    label: 'FXCNV',
    description: 'FX Conversion Entry',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'FXPNL',
    label: 'FXPNL',
    description: 'FX P&L Entry',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'FXTRD',
    label: 'FXTRD',
    description: 'FX Trade Entry',
    screen: 'Trade',
    screen_no: 1,
  },
  {
    value: 'INT',
    label: 'INR',
    description: 'Credit/Margin Interest',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'INVPNL',
    label: 'INVPNL',
    description: 'INVPNL',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'JNLC',
    label: 'JNLC',
    description: 'Journal Entry(Cash)',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'JNLS',
    label: 'JNLS',
    description: 'Journal Entry(Stock)',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'MA',
    label: 'MA',
    description: 'Merger/Acquisition',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'MEM',
    label: 'MEM',
    description: 'Memopost Entry',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'MMSWP',
    label: 'MMSWP',
    description: 'Money Market Sweep',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'NC',
    label: 'NC',
    description: 'Name Change',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'OCT',
    label: 'OCT',
    description: 'On Chain Transfer',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'OPASN',
    label: 'OPASN',
    description: 'Option Assignment',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'OPCA',
    label: 'OPCA',
    description: 'Option Corporate Action',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'OPCSH',
    label: 'OPCSH',
    description: 'Option Cash',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'OPEXC',
    label: 'OPEXC',
    description: 'Option Exercise',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'OPEXP',
    label: 'OPEXP',
    description: 'Option Expiration',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'OPTRD',
    label: 'OPTRD',
    description: 'Option Trade',
    screen: 'Trade',
    screen_no: 1,
  },
  {
    value: 'PRDCLS',
    label: 'PRDCLS',
    description: 'Period Close',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'PTC',
    label: 'PTC',
    description: 'Pass-Thru Charge',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'PTR',
    label: 'PTR',
    description: 'Pass-Thru Rebate',
    screen: 'Cash Movement',
    screen_no: 2,
  },
  {
    value: 'REO',
    label: 'REO',
    description: 'Reorganization',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'REORG',
    label: 'REORG',
    description: 'ReOrg Corp Action',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'SEG',
    label: 'SEG',
    description: 'Segregation',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'SPIN',
    label: 'SPIN',
    description: 'Stock SpinOff',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'SPLIT',
    label: 'SPLIT',
    description: 'Stock Split',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'SWP',
    label: 'SWP',
    description: 'Sweep',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
  {
    value: 'TRD',
    label: 'TRD',
    description: 'Trade Entry',
    screen: 'Trade',
    screen_no: 1,
  },
  {
    value: 'VOF',
    label: 'VOF',
    description: 'Voluntary Offering',
    screen: 'Position Movement',
    screen_no: 3,
  },
  {
    value: 'WH',
    label: 'WH',
    description: 'Withholdings',
    screen: 'Cash and/or Position Movement',
    screen_no: 4,
  },
];

export const entrySubTypeOptions = [
  {
    value: 'REG',
    label: 'REG',
  },
  {
    value: 'TAF',
    label: 'TAF',
  },
  {
    value: 'JIT',
    label: 'JIT',
  },
  {
    value: 'PROMO',
    label: 'PROMO',
  },
  { value: 'FWH', label: 'FWH' },
  { value: 'SWH', label: 'SWH' },
  { value: 'SLWH', label: 'SLWH' },
  { value: 'SNC', label: 'SNC' },
  { value: 'CNC', label: 'CNC' },
  { value: 'SCNC', label: 'SCNC' },
  { value: 'ROC', label: 'ROC' },
  { value: 'LTCG', label: 'LTCG' },
  { value: 'STCG', label: 'STCG' },
  { value: 'REOC', label: 'REOC' },
  { value: 'REOS', label: 'REOS' },
  { value: 'REOSC', label: 'REOSC' },
];

export const sideOptions = [
  { value: 'sell', label: 'Sell' },
  { value: 'sell_short', label: 'Sell Short' },
  { value: 'buy', label: 'Buy' },
];
